import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { CheckoutStateService, DeliveryMode } from '@b2b/features/cart/core/checkout-state.service';

@Component({
  selector: 'checkout-delivery-mode',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, NgxMaskDirective],
  providers: [provideNgxMask()],
  templateUrl: './checkout-delivery-mode.component.html',
  styleUrl: './checkout-delivery-mode.component.scss',
})
export class CheckoutDeliveryModeComponent implements OnInit, OnDestroy {
  selectedMode: DeliveryMode = 'CIF';
  fobForm!: FormGroup;
  today: string = new Date().toISOString().split('T')[0];

  readonly vehicleSizes: string[] = Array.from({ length: 28 }, (_, i) => `${i + 3}m`);

  private subscription = new Subscription();

  constructor(
    private checkoutState: CheckoutStateService,
    private fb: FormBuilder,
  ) {
    this.selectedMode = this.checkoutState.deliveryMode() ?? 'CIF';
  }

  ngOnInit(): void {
    this.buildFobForm();

    const saved = this.checkoutState.fobVehicleInfo();
    if (saved) {
      this.fobForm.patchValue(saved);
    }

    this.subscription.add(
      this.fobForm.valueChanges.subscribe(() => {
        this.checkoutState.setFobVehicleInfo(this.fobForm.getRawValue(), this.fobForm.valid);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get isFob(): boolean {
    return this.selectedMode === 'FOB';
  }

  get f(): { [key: string]: AbstractControl } {
    return this.fobForm.controls;
  }

  onModeChange(mode: DeliveryMode): void {
    this.selectedMode = mode;
    this.checkoutState.setDeliveryMode(mode);
    if (mode === 'FOB') {
      this.checkoutState.setFobVehicleInfo(this.fobForm.getRawValue(), this.fobForm.valid);
    }
  }

  private buildFobForm(): void {
    this.fobForm = this.fb.group({
      plate: ['', [Validators.required, Validators.minLength(7)]],
      vehicleSize: ['', Validators.required],
      brand: ['', [Validators.required, Validators.minLength(2)]],
      model: ['', [Validators.required, Validators.minLength(2)]],
      driverName: ['', [Validators.required, Validators.minLength(3)]],
      phone: ['', [Validators.required, Validators.minLength(10)]],
      pickupDate: ['', Validators.required],
    });
  }

  isFieldInvalid(field: string): boolean {
    const control = this.fobForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}
